import api from './index'

export interface FileTotalRow {
  file_status: string
  units: number
  true_debt: number | null
  deal_value: number | null
  percent: number | null
}

export interface ClawbackBreakdownRow {
  month: string
  paid_units: number
  total_debt_paid: string
  bps: string
  unit_bonus: string
  clawbacks: number
  clawback_value: string
  total_clawbacks: number
  total_clawback_value: string
}

export interface FileRow {
  dsid: string
  client: string
  state: string
  true_fpd: string | null
  fp_clear: string | null
  cancel_date: string | null
  true_debt: string
  last_draft_status: string | null
  last_draft_date: string | null
  file_status: string
  per_deal: string | null
}

export interface MyFilesData {
  name: string
  email: string
  file_totals: FileTotalRow[]
  clawback_breakdowns: ClawbackBreakdownRow[]
  files: FileRow[]
}

export type RelativeMonth = 'Last Month' | 'Current Month' | 'Next Month'

export const FILE_STATUSES = [
  'Paid',
  '3 Day Hold',
  'Pending',
  'Bad Draft',
  'Cancelled',
  'Limbo',
  'Clawback',
] as const
export type FileStatusFilter = (typeof FILE_STATUSES)[number]

interface GetFilesParams {
  fileStatus?: FileStatusFilter[]
  relativeMonth?: RelativeMonth
  sort?: string
}

export async function getFiles(
  token: string | null,
  userID: string | null,
  { fileStatus, relativeMonth, sort }: GetFilesParams = {},
): Promise<MyFilesData | null> {
  const params: Record<string, string> = {}
  if (fileStatus && fileStatus.length > 0) {
    params['filter[file_status]'] = fileStatus.join(',')
  }
  if (relativeMonth) params['filter[relative_month]'] = relativeMonth
  if (sort) params.sort = sort

  const filesPromise = await api
    .get(`/agent/files/${userID}`, {
      headers: { Authorization: `Bearer ${token}` },
      params,
    })
    .catch((err) => {
      console.error(err)
    })

  if (filesPromise && filesPromise.status === 200) {
    return filesPromise.data.data
  }
  return null
}
